import type { Translate } from 'providers/ApplicationContext';
import type { ContractSigner } from 'types';

type AdminDrawerSignersProps = {
	isCompanyRow: boolean;
	signers: ContractSigner[] | undefined;
	t: Translate;
};

export function AdminDrawerSigners({ isCompanyRow, signers, t }: Readonly<AdminDrawerSignersProps>) {
	if (!Array.isArray(signers) || !signers.length) return null;

	return (
		<div className="admin-drawer-signers">
			<div className="admin-drawer-signers__title">
				{isCompanyRow ? t('company_signatories') : t('admin_signatures')}
			</div>
			<div className="admin-drawer-signers__table-wrap">
				<table className="admin-drawer-signers__table">
					<thead>
						<tr>
							<th>{t('name')}</th>
							<th>{isCompanyRow ? t('position_in_company') : t('relationship')}</th>
							{isCompanyRow && <th>{t('authority')}</th>}
							<th>{t('signed')}</th>
						</tr>
					</thead>
					<tbody>
						{signers.map(signer => (
							<tr key={signer.kennitala}>
								<td>{signer.name}</td>
								<td>{signer.role}</td>
								{isCompanyRow && (
									<td
										className={
											signer.hasSigningAuthority
												? 'admin-drawer-signers__cell--auth'
												: 'admin-drawer-signers__cell--no-auth'
										}
									>
										{signer.hasSigningAuthority ? '✓' : '-'}
									</td>
								)}
								<td
									className={
										signer.hasSigned
											? 'admin-drawer-signers__cell--signed'
											: 'admin-drawer-signers__cell--pending'
									}
								>
									{signer.hasSigned ? t('yes') : t('pending')}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
